const { stationList } = require("constants/station");

const initialState = {
  stationList: {},
};

const station = (state = initialState, action) => {
  switch (action.type) {
    case stationList:
      return { ...state, stationList: action.payload };

    default:
      return state;
  }
};
export default station;
